import React from 'react';
import { VisibilityTrackerContainer } from '@noths/polaris-client-components';
import { visuallyHidden } from '@noths/polaris-client-styles';

import { smallPill } from 'src/styles/smallPill';
import * as elementIds from '../constants/elementIds';
import { FilterUid } from '../constants/uids';
import { FilterOptionsContainer } from '../containers/FilterOptionsContainer';
import { FilterWithFilterOptionsCount } from '../modules/selectors';
import { DELIVERY_FILTER_VISIBILITY_NAME } from '../tracking/events';
import * as styles from '../styles/FilterList.styles';

interface Props {
  filter: FilterWithFilterOptionsCount;
}

const DELIVERY_VISIBILITY_THRESHOLD = 0.7;

export const FilterListItem = ({ filter }: Props) => {
  const FilterListItemComponent = (
    <li css={styles.listItem}>
      <h3 css={styles.filterHeading}>
        {filter.title}
        {filter.selectedFilterOptionsCount > 0 && (
          <>
            <span
              data-testid={elementIds.FILTER_LIST_ITEM_COUNT}
              css={[smallPill, styles.filterCount]}
            >
              {filter.selectedFilterOptionsCount}
            </span>
            <span css={visuallyHidden}> selected</span>
          </>
        )}
      </h3>
      <FilterOptionsContainer key={filter.uid} filter={filter} />
    </li>
  );

  if (filter.uid === FilterUid.Delivery) {
    return (
      <VisibilityTrackerContainer
        sectionName={DELIVERY_FILTER_VISIBILITY_NAME}
        threshold={DELIVERY_VISIBILITY_THRESHOLD}
      >
        {FilterListItemComponent}
      </VisibilityTrackerContainer>
    );
  }

  return FilterListItemComponent;
};
